import { FilterItem } from 'palette/Filters';
import { FilterItem as ItemInterface, OnToggleFilter } from 'palette/Filters/types';
import { List, ListItem } from 'palette/List';
import { groupFilterItems } from '../helpers/items';
import './FilterGroupedItems.scss';

interface FilterGroupedItemsProps {
    items: ItemInterface[];
    onToggleFilter?: OnToggleFilter;
}

export default function FilterGroupedItems({
    items,
    onToggleFilter,
}: FilterGroupedItemsProps) {
    const groupedItems = groupFilterItems(items);
    return (
        <div className="filter-grouped-items">
            {
                Object.entries(groupedItems).map((letterItems) => {
                    const [letter, values] = letterItems;
                    return (
                        <List key={letter}>
                            <ListItem
                                label={letter}
                                labelType="large-title"
                            />
                            {
                                values.map(item => (
                                    <FilterItem
                                        key={item.value}
                                        item={item}
                                        onToggleFilter={onToggleFilter}
                                    />
                                ))
                            }
                        </List>
                    );
                })
            }
        </div>
    );
}
